let globalConfig = require('Config');

module.exports = {
    getConfigForHost() {
        let envConfig;
        switch (window.location.host) {
            case globalConfig.liveHostHomelet:
                envConfig = globalConfig.production;
                break;
            case globalConfig.stagingHost:
                envConfig = globalConfig.staging;
                break;
            default:
                envConfig = globalConfig.staging;
                break;
        }
        return envConfig;
    },
};


/** WEBPACK FOOTER **
 ** ./src/components/Managers/HttpService.js
 **/